import { fetchFoldersChronologically as fetchFoldersChronologicallyAPI } from '../../folders.api';
import {
  FOLDERS_SET,
  FOLDER_CREATED,
  FOLDER_DELETED,
  FOLDER_RENAMED,
  FOLDER_ANNOTATION_CHANGED,
  FOLDER_DECISION_DELETED,
} from '../action-types';
import { Folder } from '../../folders.types';
import { CreateFolderType } from '../foldersState.types';

export const setFolders = (rawFolders: Array<Folder>) => {
  const foldersOrderedByName = [...rawFolders];
  foldersOrderedByName.sort((a, b) => a.title.localeCompare(b.title));
  // folders are ordered chronologically from API call but should be ordered alphabetically on folders page
  const orderByName = foldersOrderedByName.map(folder => folder.folderKey);

  const folders = rawFolders.reduce(
    (acc, folder) => ({ ...acc, [folder.folderKey]: folder }),
    {},
  );
  const decisionsCountByFolder = rawFolders.reduce(
    (acc, folder) => ({ ...acc, [folder.folderKey]: folder.numberOfDecisions }),
    {},
  );

  return <const>{
    type: FOLDERS_SET,
    payload: { folders, orderByName, decisionsCountByFolder },
  };
};

export const folderCreated = (folder: CreateFolderType, source: string) =>
  <const>{
    type: FOLDER_CREATED,
    payload: { folder },
    analytics: {
      type: 'Folder FolderCreated',
      data: {
        folder_key: folder.folderKey,
        source,
      },
    },
  };

export const folderDeleted = (folderKey: string) =>
  <const>{
    type: FOLDER_DELETED,
    payload: { folderKey },
    analytics: {
      type: 'Folder FolderDeleted',
      data: {
        folder_key: folderKey,
      },
    },
  };

export const decisionDeletedFromFolder = (folderKey: string) =>
  <const>{
    type: FOLDER_DECISION_DELETED,
    payload: { folderKey },
  };

export const folderRenamed = ({
  folderKey,
  title,
  source,
}: {
  folderKey: string;
  title: string;
  source: string;
}) =>
  <const>{
    type: FOLDER_RENAMED,
    payload: { folderKey, title },
    analytics: {
      type: 'Folder FolderRenamed',
      data: {
        folder_key: folderKey,
        source,
      },
    },
  };

export const folderAnnotationChanged = ({
  folderKey,
  folderAnnotation,
}: {
  folderKey: string;
  folderAnnotation: string;
}) =>
  <const>{
    type: FOLDER_ANNOTATION_CHANGED,
    payload: { folderKey, folderAnnotation },
  };

export const fetchFoldersChronologically = () => async (dispatch: Function) => {
  const folders = await fetchFoldersChronologicallyAPI();
  dispatch(setFolders(folders));
};

export type FolderActions = ReturnType<
  | typeof setFolders
  | typeof folderCreated
  | typeof folderDeleted
  | typeof decisionDeletedFromFolder
  | typeof folderRenamed
  | typeof folderAnnotationChanged
>;
